import React from 'react';

class News extends React.Component {
    render() {
        return (
            <div className="news">
                <div className="container"><h2 className="news__title">Новости</h2>
                    <div className="news__subtitle">Мы публикуем самое интересное и полезное</div>
                    <div className="news__news-block">
                        <div className="news__item">
                            <div className="news__img-cont"><img className="news__news-img"
                                                                 src="images/../images/bonch2.jpg" alt=""
                                                                 role="presentation"/></div>
                            <div className="news__underscore"></div>
                            <h3 className="news__news-title">Bonch HackDay</h3><p className="news__news-text">АО «Заубер
                            Банк», ООО «Системы информации и связи» и ООО «Виз Софтвэр Консалтинг» приглашают студентов
                            принять участие в хакатоне, посвящённом современным перспективным технологиям. Мероприятие
                            пройдёт на территории Санкт-Петербургского государственного университета телекоммуникаций
                            им. проф. М.А.Бонч-Бруевича 23-25 марта 2018 года.</p><a className="news__more"
                                                                                     href="/news#news1">Читать далее<img
                            className="news__arrow" src="images/arrow.svg" width="15" height="11" alt=""
                            role="presentation"/></a></div>
                        <div className="news__item">
                            <div className="news__img-cont"><img className="news__news-img"
                                                                 src="images/../images/export_day.jpg" alt=""
                                                                 role="presentation"/></div>
                            <div className="news__underscore"></div>
                            <h3 className="news__news-title">День экспорта: цифровая экономика</h3><p
                            className="news__news-text">Компания "Системы информации и связи" и "Заубер Банк" приняли
                            участие в конференции "День экспорта: цифровая экономика", организованной Региональным
                            Интегрированным Центром - Санкт-Петербург и Комитетом по развитию предпринимательства и
                            потребительского рынка Санкт-Петербурга на площадке Санкт-Петербургской торгово-промышленной
                            палаты.</p><a className="news__more" href="/news#news3">Читать далее<img
                            className="news__arrow" src="images/arrow.svg" width="15" height="11" alt=""
                            role="presentation"/></a></div>
                        <div className="news__item">
                            <div className="news__img-cont"><img className="news__news-img"
                                                                 src="images/../images/korporativ.jpg" alt=""
                                                                 role="presentation"/></div>
                            <div className="news__underscore"></div>
                            <h3 className="news__news-title">Корпоратив</h3><p className="news__news-text">Корпоратив -
                            это обычно когда все собираются вместе, говорят, как много всяческих достижений они все
                            вместе уже достигли, как много достигают прямо сейчас и как много ещё достигнут - только дай
                            время. </p><a className="news__more" href="/news#news2">Читать далее<img
                            className="news__arrow" src="images/arrow.svg" width="15" height="11" alt=""
                            role="presentation"/></a></div>
                    </div>
                </div>
            </div>
        )
    }
}

export default News;


// WEBPACK FOOTER //
// ./src/Components/MainPage/News.js